import React, { Component } from 'react'
import RestaurantList from '../restaurants/RestaurantList'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { addFavorite2, setDistanceList, updateSortOptions, updateSortVisible } from '../../store/actions/restaurantActions'
import Checkbox from '../layout/Checkbox'
import Select from 'react-select';
import { tagFunctions } from '../restaurants/Tags'
import { hoursFunctions } from '../restaurants/Hours'
import firebase from '../../config/fbConfig'
import styled from "styled-components";
import Carousel from "../../infinite-carousel/Carousel";
import HorizontalSlider from "../../infinite-carousel/HorizontalSlider";

class Dashboard extends Component {

  constructor (props){
    super(props);
    this.state = {
    sortFavorites: false,
    sortOnlineNotMenu: false,
    sortOpen: false,
    sortPickup: true,
    sortDistance: true,
    anyTags: true,
    allTags: false,
    sortTags: '',
    openList: '',
    options: '',
    allContent: '',
    sortNames:'',
    sortName:'',
    sortCombined:'',
    combinedSort:'',
    carouselPosition:1,
    summaryChange:false,
    
    httpResponse:'',
    locationList:'',
    locationList2:'',
    distanceList:{},
    distanceList2:{},
    fullDistanceList:{},

    doOnce:true,
    doOnceAPI:true,
    doOnceDistance:true,
    prevDistanceListLength:999,
    sliderWidth:document.body.clientWidth - 20
        }
  }

  resizeEvent(that){
    console.log(document.body.clientWidth + ' wide by ' + document.body.clientHeight+' high');
    if(that.state.sliderWidth!==document.body.clientWidth){
      if(document.body.clientWidth<767){
        that.setState({sliderWidth:document.body.clientWidth - 20})
      } 
      else{
        that.setState({sliderWidth:document.body.clientWidth - 280})
      }
    }
  }

  componentDidMount(props) {  

  window.addEventListener("resize", ()=>this.resizeEvent(this));

  if(document.body.clientWidth<767){
    this.setState({sliderWidth:document.body.clientWidth - 20})
  } 
  else{
    this.setState({sliderWidth:document.body.clientWidth - 280})
  }

  if(this.props.restaurant && this.props.restaurant.sortOptions){
    console.log('load sort options');
    const loadSortOptions = this.props.restaurant.sortOptions;
    this.setState({
      ...this.state,
      ...loadSortOptions
      })  
    }
  if(this.props.restaurant && this.props.restaurant.sortVisible){
    this.props.updateSortVisible(false);
    document.body.style.overflow = 'scroll';
  }
  console.log("MOUNT");
  this.setState({mount:true});
  this.setState({
    httpResponse:'',
    locationList:'',
    locationList2:'',
    distanceList:{},
    distanceList2:{},
    fullDistanceList:{},
    doOnce:true,
    doOnceAPI:true,
    doOnceDistance:true,
    prevDistanceListLength:999
        }) 
  }


  componentDidUpdate(){
    if (!this.props.auth.uid) return <Redirect to='/signin' />

    var openList = hoursFunctions.compileHours(this.props.restaurants);
    var options = tagFunctions.compileTags(this.props.restaurants);
    var primaryTags = tagFunctions.compilePrimaryTags(this.props.restaurants);
    if (JSON.stringify(this.state.openList)!==JSON.stringify(openList)){
      this.setState({openList:openList})
    }
    if (JSON.stringify(this.state.options)!==JSON.stringify(options)){
      this.setState({options:options})
    }
    if (JSON.stringify(this.state.primaryTags)!==JSON.stringify(primaryTags)){
      this.setState({primaryTags:primaryTags})
    }

    if(this.props.restaurants && this.props.restaurants.length !== this.state.sortNames.length){
      var sortNames = [];
      for(var res in this.props.restaurants){
        sortNames.push({"value":this.props.restaurants[res].name, "label":this.props.restaurants[res].name})
      }
      this.setState({sortNames:sortNames});
    }

    if(this.props.restaurants && options && this.state.combinedSort.length !== (this.props.restaurants.length + options.length)){
      var sortNames = [];
      var combined = [];
      for(var res in this.props.restaurants){
        sortNames.push({"value":this.props.restaurants[res].name, "label":this.props.restaurants[res].name})
      }
      combined = sortNames.concat(options);
      this.setState({combinedSort:combined});
    }

    

    // IF THERE IS NO DISTANCE DATA DO THIS
    if(this.props.user && this.props.restaurants && !this.props.user.distanceList){
        console.log('using API');
      // find restaurants that have location data
      if(this.props.restaurants && this.state.locationList === ''){
        var locations = {};
        locations = this.props.restaurants.filter(restaurant=> restaurant.location !== undefined);
        var locationList = [];
        locations = locations.slice(0,90);
        locations.map(location=>
          locationList.push([location.restaurantId, location.location])
        )
        console.log("updating locationList");
        this.setState({locationList:locationList});
      }

      // Bing maps API for distance data
      if(this.state.doOnceAPI && this.props.auth && this.state.httpResponse === '' && this.state.locationList !== ''
        && this.props.user && this.props.user.location){
        var location = this.props.user.location;
        console.log('createUrl');     
        this.createUrl(location, this.state.locationList); 
        this.setState({doOnceAPI:false})
      }

      // create distanceList from API response
      if(this.state.httpResponse !== '' && this.isDistanceList(this.state.distanceList)){
        var httpResponse = this.state.httpResponse;
        //get array of distances from httpresponse
        const results = httpResponse.resourceSets[0].resources[0].results.map((result)=>{return(result.travelDistance)});
        var riffle = [];
        for (var i = 0; i < this.state.locationList.length; i ++){
          riffle.push([this.state.locationList[i][0],results[i]]);
        }
        console.log('setting distanceList');
        this.setState({distanceList:Object.fromEntries(riffle)});
        this.props.setDistanceList(Object.fromEntries(riffle), this.props.user);
        console.log('resetting httpResponse and distanceList 1');
        this.setState({httpResponse:'',distanceList:{}});
      }  
    }
    
    if(this.state.httpResponse !== '' && this.props.user && this.props.user.distanceList && this.props.user.distanceList.length && Object.entries(this.props.user.distanceList).length !== this.props.restaurants.length){
      console.log("LENGTHS OF REST DIST");
      console.log(this.props.restaurants.length);
      console.log(this.props.user.distanceList.length);
      console.log(this.distanceList);
      console.log('resetting httpResponse and distanceList 2');
      this.setState({httpResponse:'',distanceList:{}})
    }

    // IF THERE IS DISTANCE DATA DO THIS 
    if(this.props.user && this.props.user.distanceList && Object.entries(this.props.user.distanceList) && Object.entries(this.props.user.distanceList).length!==this.state.prevDistanceListLength && this.state.doOnceDistance && this.state.httpResponse === '' && this.props.user && this.props.user.distanceList!==undefined && this.props.user.distanceList && this.props.restaurants && this.isDistanceList(this.state.distanceList)){
      console.log('checking stored distance data');
      console.log("LENGTHS OF REST DIST2");
      console.log(this.props.restaurants.length);
      console.log(Object.entries(this.props.user.distanceList).length);
      console.log('prevDistanceListLength');
      console.log(this.state.prevDistanceListLength);
      console.log(Object.entries(this.props.user.distanceList).length);
      if(this.props.restaurants.length === Object.entries(this.props.user.distanceList).length){
        console.log("EWQUAOTLL")
        this.setState({doOnceDistance:false})
      }
      if(this.state.locationList2 === ''){
      var locationsCheck = {};
      locationsCheck = this.props.restaurants.filter(restaurant=> restaurant.location !== undefined && restaurant.location !== '');
      var locationListCheck = [];
      locationsCheck.map(location=>
        locationListCheck.push([location.restaurantId, location.location])
      )
      const newLocations = locationListCheck.filter(location => !this.containsObject(location[0],Object.keys(this.props.user.distanceList)))
      if(newLocations.length !== 0){
        this.setState({locationList2:newLocations});  
      }

      }

      this.setState({distanceList:this.props.user.distanceList})       
    }

    if(this.props.user && this.props.user.distanceList && Object.entries(this.props.user.distanceList).length !== this.state.prevDistanceListLength && this.state.httpResponse === '' && this.state.locationList2 !== '' && this.isDistanceList(this.state.distanceList2)){
        console.log('locationList2');
        console.log(this.state.locationList2);
        console.log(this.state.locationList2.slice(0,90));
        this.setState({prevDistanceListLength:Object.entries(this.props.user.distanceList).length})
        if(Object.entries(this.props.user.distanceList).length !== this.state.prevDistanceListLength){
          this.createUrl(this.props.user.location, this.state.locationList2.slice(0,90));        
        }
        
      }


    if(this.state.httpResponse !== '' && this.isDistanceList(this.state.distanceList2) && this.state.locationList2 !== ''){
            var httpResponse2 = this.state.httpResponse;
            //get array of distances from httpresponse
            const results2 = httpResponse2.resourceSets[0].resources[0].results.map((result)=>{return(result.travelDistance)});
            var riffle2 = [];
            for (var k = 0; k < this.state.locationList2.slice(0,90).length; k ++){
              riffle2.push([this.state.locationList2.slice(0,90)[k][0],results2[k]]);
            }
            this.setState({distanceList2:Object.fromEntries(riffle2)});
          }

    if(!this.isDistanceList(this.state.distanceList) && !this.isDistanceList(this.state.distanceList2) && this.isDistanceList(this.state.fullDistanceList)){
      const fullDistanceList = {...this.state.distanceList,...this.state.distanceList2};
      this.props.setDistanceList(fullDistanceList, this.props.user);
      this.setState({
        httpResponse:'',
        locationList:'',
        locationList2:'',
        distanceList:{},
        distanceList2:{},
        fullDistanceList:{}
      });
    }
    
    if(this.props.restaurant){
      if(this.props.restaurant.sortOptions && this.props.restaurant.sortOptions.summaryChange){
        console.log('summaryChange')
        this.setState({
          sortTags:this.props.restaurant.sortOptions.sortTags,
          sortCombined:this.props.restaurant.sortOptions.sortCombined,
          summaryChange:false
        })
        this.props.updateSortOptions({summaryChange:false})
      }
      else if(this.props.restaurant.sortOptions === undefined || JSON.stringify(this.props.restaurant.sortOptions) !== JSON.stringify(this.state)){
       console.log('test change')
       this.props.updateSortOptions(this.state);
      }  
    }
  }

  containsObject(obj, list) {
    var i;
    for (i = 0; i < list.length; i++) {
        if (list[i] === obj) {
            return true;
        }
    }

    return false;
  }

  // is distanceList empty?
  isDistanceList(distanceList){
      for (var i in distanceList){
        return false}
      return true
    }

  createUrl = (location, locationList) => {

    for(var locs in locationList){
      if(JSON.stringify(locationList[locs][1]) === JSON.stringify(location)){
        console.log('conflict');
        location = [location[0] + 0.00001, location[1]];
      }
    }

    var fullUrl ='';
    locationList.map(location=>
      fullUrl = fullUrl.concat(location[1].toString()+';')
    )
    fullUrl = fullUrl.slice(0,-1);
    this.calculateDistanceMatrix(location, fullUrl);
  }

  calculateDistanceMatrix = (location1, fullUrl) => {
    const Http = new XMLHttpRequest();
    const url = 'https://dev.virtualearth.net/REST/v1/Routes/DistanceMatrix?origins='+location1[0]+','+location1[1]+'&destinations='+fullUrl+'&travelMode=walking&distanceUnit=mi&key=AkkmVqZTTAl0pdIReyon_6fwQ9WkzPuTxhYYqAAjV08oE2_jX_OqCj1Dbytnlh_O'

    Http.open("GET", url);
    Http.send();
    const that = this;

    Http.onreadystatechange=function(){
      if(this.readyState === 4 && this.status === 200 && that.state.httpResponse !== Http.responseText){
        var parsedJSON = JSON.parse(Http.responseText);
        that.setState({httpResponse:parsedJSON})
      }
    }   
  }

  selectFocus = ()=>{
    document.getElementById("anyTags").scrollIntoView();
  }
    
  handleSelect = (selection) =>{
    this.setState({ sortTags: selection });
  }

  handleAllContent = (selection) =>{
    this.setState({ allContent: selection })
  }

  handleSortNames = (selection) => {
    this.setState({sortName:selection})
  }

  handleSortCombined = (selection) => {
    this.setState({sortName: selection.filter(item => JSON.stringify(this.state.sortNames).includes(JSON.stringify(item))) }); 
    this.setState({ sortTags: selection.filter(item => this.state.options.includes(item)) });
    this.setState({sortCombined: selection})
  }

  handleCheck = (e) => {
    if(e.target.id==="anyTags"){
      this.setState({
        "allTags": false
      })  
    }
    if(e.target.id==="allTags"){
      this.setState({
        "anyTags": false
      })  
    }
    if(e.target.id !== 'sortFavorites'){
      this.setState({
        [e.target.id]: e.target.checked
       })   
    }
    else{
      if(this.props.user.firstName !== "Guest"){
      this.setState({
        [e.target.id]: e.target.checked
       })   
      }
      else if(this.props.user.firstName === "Guest"){
        alert("Guest Users may not add favorites")
      }
    }
   
 } 
  
  closeFunction =(e)=>{
    this.props.updateSortVisible(false);
    document.body.style.overflow = 'scroll';
  }

  onFavorite = (project) => {
  if(this.props.user.firstName === "Guest"){
    alert("Guest Users may not add favorites")  
  }
  else{
    this.props.addFavorite2(project);
  }
    }


  render() {
    //console.log('render');
    const { auth, favorites, restaurants, user } = this.props;
    
    const Container = styled.section`
      width: 500px;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 0 auto;
      position: relative;
      overflow: hidden;
      padding: 10px;
      @media screen and (max-width: 768px) {
        width: 300px;
      }
    `;
    
    if (!auth.uid) return <Redirect to='/signin' />
    if (user && user.email === 'testbotuser@testuser.com') return <Redirect to='/about' />

    return (
        <div>
      { auth && restaurants && (user || auth.isAnonymous) && favorites &&
        <div className='topBar'>
        <div className="centerMe">
      <div className="wrapper4" style={{height:"calc(100vh - 70px)", position:"sticky", top:"70px", "alignSelf":"flex-start", overflow:"scroll"}}>
      <h5>Sorting Options</h5>
        <div className="sortOptionsMenu">
            <Checkbox label = 'Contains any of the selected tags' id='anyTags' isSelected={this.state.anyTags} onCheckboxChange = {this.handleCheck} />
            <Checkbox label = 'Contains all of the selected tags' id='allTags' isSelected={this.state.allTags} onCheckboxChange = {this.handleCheck} />
            <h6>Tags</h6>
            <Select isMulti options={this.state.options} onFocus={this.selectFocus} value={this.state.sortTags} onChange={this.handleSelect} maxMenuHeight={100} />
            <Checkbox label = 'Online Ordering Available' id='sortOnlineNotMenu' isSelected = {this.state.sortOnlineNotMenu} onCheckboxChange = {this.handleCheck} />
            <Checkbox label = 'Include Pickup' id='sortPickup' isSelected = {this.state.sortPickup} onCheckboxChange = {this.handleCheck} />
            <Checkbox label = 'Currently Open' id='sortOpen' isSelected = {this.state.sortOpen} onCheckboxChange = {this.handleCheck} />
            {/* <Select options={allContentOptions} onChange={this.handleAllContent}/> */}
            <h6>Restaurants</h6>
            <Select isMulti value={this.state.sortName} options={this.state.sortNames} onChange={this.handleSortNames} maxMenuHeight={100}/>
            <Checkbox label = 'Distance' id='sortDistance' isSelected={this.state.sortDistance} onCheckboxChange = {this.handleCheck} />
            <Checkbox label = 'Favorites' id='sortFavorites' isSelected = {this.state.sortFavorites} onCheckboxChange = {this.handleCheck} />
        </div>
      </div>
      <div className="wrapperTEST">
        <div className="row2" id="sliderSize">
          <div className="onTop"> 
            { 
              <Select isMulti style = {{"font-size":"16px"}} placeholder={'Search by Restaurant or Tag...'} options={this.state.combinedSort} onFocus={this.selectFocus} value = {this.state.sortCombined} onChange={this.handleSortCombined} />
            }
          </div>
          {document.getElementById('sliderSize') && this.state.primaryTags && 
            <div style={{width: this.state.sliderWidth, overflow: "hidden"}}>
              <div className="sliderContainer" style={{paddingTop: "10px", display: "flex", flexFlow: "row", margin: "auto", overflowX: "scroll", overflowY: "hidden", height: "100px", width: this.state.sliderWidth }}>
                <HorizontalSlider contents={this.state.primaryTags}/>
              </div>
            </div>
          }
          { this.props.user && this.props.user.distanceList && Object.entries(this.props.user.distanceList).length < Object.entries(this.props.restaurants).length &&
            <div style={{ display: "flex", flexFlow: "column", margin: "auto", textAlign: "center"}}>
              <span>{"Calculating distances " + Object.entries(this.props.user.distanceList).length + ' / ' + Object.entries(this.props.restaurants).length}</span>
              <span>This will only happen when you first sign up, when you change your address, or when new restaurants are added.</span>
            </div>
          }
          <RestaurantList distanceList = {this.state.distanceList} onFavorite = {this.onFavorite} favorites = {favorites} sortOptions = {this.state}/>
        </div>
      </div>
        </div>
        </div>
    }
      </div>
    )
  }
}


const mapStateToProps = (state) => {
  const user = state.firestore.data.users
                && state.firestore.data.users[state.firebase.auth.uid]
  return {
    auth: state.firebase.auth,
    restaurants: state.firestore.ordered.restaurants,
    restaurant: state.restaurant,
    favorites: state.firestore.data.favorites,
    user
  }
}

const mapDispatchToProps = dispatch => {
  return {
    addFavorite2: (project) => dispatch(addFavorite2(project)),
    setDistanceList: (distanceList, user) => dispatch(setDistanceList(distanceList, user)),
    updateSortOptions: (state) => dispatch(updateSortOptions(state)),
    updateSortVisible: (sortVisible) => dispatch(updateSortVisible(sortVisible))
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(Dashboard)